import _extends from "@babel/runtime/helpers/extends";
import MuiDialog from "@mui/material/Dialog";
import MuiDialogActions from "@mui/material/DialogActions";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogContentText from "@mui/material/DialogContentText";
import MuiDialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import classNames from "classnames";
import React from "react";
import Button from "../Button";
import ButtonGroup from "../ButtonGroup";
import Typography from "../Typography";
import useStyles from "./styles";
export const Dialog = props => {
  const {
    actions,
    content,
    children,
    id,
    fullWidth,
    onClose,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    open,
    title,
    className,
    disableBackdropClick,
    disableClose,
    ...otherProps
  } = props;
  const classes = useStyles(props);
  return /*#__PURE__*/React.createElement(MuiDialog, _extends({}, otherProps, {
    id: id,
    open: open,
    className: classNames("prmbl-dialog", className),
    fullWidth: fullWidth,
    onClose: (event, reason) => {
      if (disableBackdropClick && reason === "backdropClick") {
        return;
      }
      if (onClose) onClose(event, reason);
    },
    TransitionProps: {
      onEnter: onEnter,
      onEntered: onEntered,
      onEntering: onEntering,
      onExit: onExit,
      onExited: onExited,
      onExiting: onExiting,
      "aria-labelledby": id ? `${id}-title` : undefined,
      "aria-label": id ? undefined : title,
      ...otherProps.TransitionProps
    },
    classes: {
      paper: classes.dialog,
      ...otherProps.classes
    }
  }), /*#__PURE__*/React.createElement(MuiDialogTitle, {
    id: id ? `${id}-title` : undefined,
    className: classNames("prmbl-dialog-title", classes.title)
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "span",
    variant: "h6"
  }, title)), /*#__PURE__*/React.createElement(Button, {
    type: "icon",
    size: "small",
    disabled: disableClose,
    onClick: onClose,
    className: classNames("prmbl-dialog-close", classes.closeButton),
    "aria-label": "Close this Dialog"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(MuiDialogContent, {
    className: classNames("prmbl-dialog-content", classes.dialogContent)
  }, typeof children === "string" || typeof content === "string" ? /*#__PURE__*/React.createElement(MuiDialogContentText, null, children || content) : /*#__PURE__*/React.createElement(React.Fragment, null, children || content)), actions && /*#__PURE__*/React.createElement(MuiDialogActions, {
    className: classNames("prmbl-dialog-actions", classes.buttons)
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    layout: "right"
  }, actions)));
};
export default Dialog;